import React from 'react';
import { useIntl } from 'react-intl';
import useUser from 'hooks/useUser';
import useCustomer from 'hooks/useCustomer';
import { Select, Space } from 'antd';
import messages from 'translations/messages';
import NoAccessTag from 'components/NoAccessTag';

const extraFields = `
  dataSources {
    id
    title
    type
  }
`;

const DataSourceSelect = ({ customerId, value, onChange, allowClear, ...rest }) => {
  const { formatMessage: $t } = useIntl();
  const { customer, loading } = useCustomer({ customerId, extraFields });
  const { hasDataSourceAccess } = useUser();

  const options = customer?.dataSources.map(dataSource => {
    const hasAccess = hasDataSourceAccess(dataSource.id);
    return {
      value: dataSource.id,
      disabled: !hasAccess,
      label: (
        <Space>
          {dataSource.title}
          {!hasAccess && <NoAccessTag />}
        </Space>
      ),
    };
  });

  return (
    <Select
      loading={loading}
      value={loading ? undefined : value}
      onChange={onChange}
      showSearch
      optionFilterProp="children"
      placeholder={$t(messages[allowClear ? 'allDataSources' : 'selectDataSource'])}
      allowClear={allowClear}
      options={options}
      {...rest}
    />
  );
};

export default DataSourceSelect;
